export function isDataTransferItem(f) {
    return f && "getAsFile" in f;
}
export function isArrayOfStrings(value) {
    return Array.isArray(value) && value.every((v) => typeof v === "string");
}
export function isString(value) {
    return typeof value === "string";
}
export function isBrowser() {
    return typeof window !== "undefined";
}
